import React from "react";
import ConfirmationModal from "app/components/common/ConfirmationModal";

const DeleteAgentConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  isLoading,
}) => {
  return (
    <ConfirmationModal
      show={show}
      onHide={onHide}
      onConfirm={onConfirm}
      title="Delete Agent?"
      confirmLabel="Delete"
      confirmVariant="danger"
      isLoading={isLoading}
      loadingLabel="Deleting..."
      className="delete-agent-modal-wrapper"
    >
      <div className="my-3">
        <ul>
          <li>
            This won't affect previously compiled reports, but will apply to
            existing jobs with this agent.
          </li>
          <li>This action cannot be undone.</li>
        </ul>
      </div>
    </ConfirmationModal>
  );
};

export default DeleteAgentConfirmationModal;
